import type { BracketRoundType, BracketRegion } from '@bracketblitz/shared-types';

export interface TournamentGame {
  id: string;
  round: BracketRoundType;
  region?: BracketRegion;
  team1Id?: string;
  team2Id?: string;
  team1Seed?: number;
  team2Seed?: number;
  nextGameId?: string;
  isPlayIn?: boolean;
  team1Score?: number;
  team2Score?: number;
}

export interface TournamentRound {
  name: string;
  round: BracketRoundType;
  gameCount: number;
  games: TournamentGame[];
}

// ─── 2026 NCAA Tournament ──────────────────────────────────────────────────────
// Official bracket announced Selection Sunday, March 15 2026
// No. 1 seeds: Duke (East), Arizona (West), Michigan (Midwest), Florida (South)
// First Four:
//   game-0-1: Miami (Ohio) vs SMU         → Midwest 11 seed slot (game-1-29)
//   game-0-2: Texas vs NC State           → West 11 seed slot   (game-1-13)
//   game-0-3: UMBC vs Howard              → Midwest 16 seed slot (game-1-25)
//   game-0-4: Prairie View A&M vs Lehigh  → South 16 seed slot  (game-1-17)

export const firstFourGames: TournamentGame[] = [
  {
    id: 'game-0-1',
    round: 'first_four',
    region: 'midwest',
    team1Id: 'team-miami-oh',
    team2Id: 'team-smu',
    team1Seed: 11,
    team2Seed: 11,
    team1Score: 89,
    team2Score: 79,
    nextGameId: 'game-1-29',
    isPlayIn: true,
  },
  {
    id: 'game-0-2',
    round: 'first_four',
    region: 'west',
    team1Id: 'team-texas',
    team2Id: 'team-nc-state',
    team1Seed: 11,
    team2Seed: 11,
    team1Score: 79,
    team2Score: 71,
    nextGameId: 'game-1-13',
    isPlayIn: true,
  },
  {
    id: 'game-0-3',
    round: 'first_four',
    region: 'midwest',
    team1Id: 'team-umbc',
    team2Id: 'team-howard',
    team1Seed: 16,
    team2Seed: 16,
    team1Score: 80,
    team2Score: 70,
    nextGameId: 'game-1-25',
    isPlayIn: true,
  },
  {
    id: 'game-0-4',
    round: 'first_four',
    region: 'south',
    team1Id: 'team-prairie-view',
    team2Id: 'team-lehigh',
    team1Seed: 16,
    team2Seed: 16,
    team1Score: 67,
    team2Score: 55,
    nextGameId: 'game-1-17',
    isPlayIn: true,
  },
];

export const firstRoundGames: TournamentGame[] = [
  // ── EAST REGION ─────────────────────────────────────────────
  // Standard bracket pairing: 1v16, 8v9, 5v12, 4v13, 6v11, 3v14, 7v10, 2v15
  {
    id: 'game-1-1',
    round: 'first_round',
    region: 'east',
    team1Id: 'team-duke',
    team2Id: 'team-siena',
    team1Seed: 1,
    team2Seed: 16,
    team1Score: 71,
    team2Score: 65,
    nextGameId: 'game-2-1',
  },
  {
    id: 'game-1-2',
    round: 'first_round',
    region: 'east',
    team1Id: 'team-ohio-st',
    team2Id: 'team-tcu',
    team1Seed: 8,
    team2Seed: 9,
    team1Score: 66,
    team2Score: 64,
    nextGameId: 'game-2-1',
  },
  {
    id: 'game-1-3',
    round: 'first_round',
    region: 'east',
    team1Id: 'team-st-johns',
    team2Id: 'team-northern-iowa',
    team1Seed: 5,
    team2Seed: 12,
    team1Score: 79,
    team2Score: 53,
    nextGameId: 'game-2-2',
  },
  {
    id: 'game-1-4',
    round: 'first_round',
    region: 'east',
    team1Id: 'team-kansas',
    team2Id: 'team-cal-baptist',
    team1Seed: 4,
    team2Seed: 13,
    team1Score: 68,
    team2Score: 60,
    nextGameId: 'game-2-2',
  },
  {
    id: 'game-1-5',
    round: 'first_round',
    region: 'east',
    team1Id: 'team-louisville',
    team2Id: 'team-south-florida',
    team1Seed: 6,
    team2Seed: 11,
    team1Score: 83,
    team2Score: 79,
    nextGameId: 'game-2-3',
  },
  {
    id: 'game-1-6',
    round: 'first_round',
    region: 'east',
    team1Id: 'team-michigan-st',
    team2Id: 'team-north-dakota-st',
    team1Seed: 3,
    team2Seed: 14,
    team1Score: 92,
    team2Score: 67,
    nextGameId: 'game-2-3',
  },
  {
    id: 'game-1-7',
    round: 'first_round',
    region: 'east',
    team1Id: 'team-ucla',
    team2Id: 'team-ucf',
    team1Seed: 7,
    team2Seed: 10,
    team1Score: 75,
    team2Score: 71,
    nextGameId: 'game-2-4',
  },
  {
    id: 'game-1-8',
    round: 'first_round',
    region: 'east',
    team1Id: 'team-connecticut',
    team2Id: 'team-furman',
    team1Seed: 2,
    team2Seed: 15,
    team1Score: 82,
    team2Score: 71,
    nextGameId: 'game-2-4',
  },
  // ── WEST REGION ─────────────────────────────────────────────
  {
    id: 'game-1-9',
    round: 'first_round',
    region: 'west',
    team1Id: 'team-arizona',
    team2Id: 'team-liu',
    team1Seed: 1,
    team2Seed: 16,
    team1Score: 92,
    team2Score: 58,
    nextGameId: 'game-2-5',
  },
  {
    id: 'game-1-10',
    round: 'first_round',
    region: 'west',
    team1Id: 'team-villanova',
    team2Id: 'team-utah-st',
    team1Seed: 8,
    team2Seed: 9,
    team1Score: 86,
    team2Score: 76,
    nextGameId: 'game-2-5',
  },
  {
    id: 'game-1-11',
    round: 'first_round',
    region: 'west',
    team1Id: 'team-wisconsin',
    team2Id: 'team-high-point',
    team1Seed: 5,
    team2Seed: 12,
    team1Score: 83,
    team2Score: 82,
    nextGameId: 'game-2-6',
  },
  {
    id: 'game-1-12',
    round: 'first_round',
    region: 'west',
    team1Id: 'team-arkansas',
    team2Id: 'team-hawaii',
    team1Seed: 4,
    team2Seed: 13,
    team1Score: 97,
    team2Score: 78,
    nextGameId: 'game-2-6',
  },
  {
    id: 'game-1-13',
    round: 'first_round',
    region: 'west',
    team1Id: 'team-byu',
    team2Id: 'team-texas',
    team1Seed: 6,
    team2Seed: 11,
    team1Score: 79,
    team2Score: 71,
    nextGameId: 'game-2-7',
  },
  {
    id: 'game-1-14',
    round: 'first_round',
    region: 'west',
    team1Id: 'team-gonzaga',
    team2Id: 'team-kennesaw-st',
    team1Seed: 3,
    team2Seed: 14,
    team1Score: 73,
    team2Score: 64,
    nextGameId: 'game-2-7',
  },
  {
    id: 'game-1-15',
    round: 'first_round',
    region: 'west',
    team1Id: 'team-miami-fl',
    team2Id: 'team-missouri',
    team1Seed: 7,
    team2Seed: 10,
    team1Score: 80,
    team2Score: 66,
    nextGameId: 'game-2-8',
  },
  {
    id: 'game-1-16',
    round: 'first_round',
    region: 'west',
    team1Id: 'team-purdue',
    team2Id: 'team-queens',
    team1Seed: 2,
    team2Seed: 15,
    team1Score: 104,
    team2Score: 71,
    nextGameId: 'game-2-8',
  },
  // ── SOUTH REGION ─────────────────────────────────────────────
  {
    id: 'game-1-17',
    round: 'first_round',
    region: 'south',
    team1Id: 'team-florida',
    team2Id: 'team-prairie-view',
    team1Seed: 1,
    team2Seed: 16,
    team1Score: 114,
    team2Score: 55,
    nextGameId: 'game-2-9',
  },
  {
    id: 'game-1-18',
    round: 'first_round',
    region: 'south',
    team1Id: 'team-clemson',
    team2Id: 'team-iowa',
    team1Seed: 8,
    team2Seed: 9,
    team1Score: 67,
    team2Score: 61,
    nextGameId: 'game-2-9',
  },
  {
    id: 'game-1-19',
    round: 'first_round',
    region: 'south',
    team1Id: 'team-vanderbilt',
    team2Id: 'team-mcneese',
    team1Seed: 5,
    team2Seed: 12,
    team1Score: 78,
    team2Score: 68,
    nextGameId: 'game-2-10',
  },
  {
    id: 'game-1-20',
    round: 'first_round',
    region: 'south',
    team1Id: 'team-nebraska',
    team2Id: 'team-troy',
    team1Seed: 4,
    team2Seed: 13,
    team1Score: 76,
    team2Score: 47,
    nextGameId: 'game-2-10',
  },
  {
    id: 'game-1-21',
    round: 'first_round',
    region: 'south',
    team1Id: 'team-north-carolina',
    team2Id: 'team-vcu',
    team1Seed: 6,
    team2Seed: 11,
    team1Score: 82,
    team2Score: 78,
    nextGameId: 'game-2-11',
  },
  {
    id: 'game-1-22',
    round: 'first_round',
    region: 'south',
    team1Id: 'team-illinois',
    team2Id: 'team-penn',
    team1Seed: 3,
    team2Seed: 14,
    team1Score: 105,
    team2Score: 70,
    nextGameId: 'game-2-11',
  },
  {
    id: 'game-1-23',
    round: 'first_round',
    region: 'south',
    team1Id: 'team-saint-marys',
    team2Id: 'team-texas-am',
    team1Seed: 7,
    team2Seed: 10,
    team1Score: 63,
    team2Score: 50,
    nextGameId: 'game-2-12',
  },
  {
    id: 'game-1-24',
    round: 'first_round',
    region: 'south',
    team1Id: 'team-houston',
    team2Id: 'team-idaho',
    team1Seed: 2,
    team2Seed: 15,
    team1Score: 78,
    team2Score: 47,
    nextGameId: 'game-2-12',
  },
  // ── MIDWEST REGION ─────────────────────────────────────────────
  {
    id: 'game-1-25',
    round: 'first_round',
    region: 'midwest',
    team1Id: 'team-michigan',
    team2Id: 'team-howard',
    team1Seed: 1,
    team2Seed: 16,
    team1Score: 101,
    team2Score: 80,
    nextGameId: 'game-2-13',
  },
  {
    id: 'game-1-26',
    round: 'first_round',
    region: 'midwest',
    team1Id: 'team-georgia',
    team2Id: 'team-saint-louis',
    team1Seed: 8,
    team2Seed: 9,
    team1Score: 102,
    team2Score: 77,
    nextGameId: 'game-2-13',
  },
  {
    id: 'game-1-27',
    round: 'first_round',
    region: 'midwest',
    team1Id: 'team-texas-tech',
    team2Id: 'team-akron',
    team1Seed: 5,
    team2Seed: 12,
    team1Score: 91,
    team2Score: 71,
    nextGameId: 'game-2-14',
  },
  {
    id: 'game-1-28',
    round: 'first_round',
    region: 'midwest',
    team1Id: 'team-alabama',
    team2Id: 'team-hofstra',
    team1Seed: 4,
    team2Seed: 13,
    team1Score: 90,
    team2Score: 70,
    nextGameId: 'game-2-14',
  },
  {
    id: 'game-1-29',
    round: 'first_round',
    region: 'midwest',
    team1Id: 'team-tennessee',
    team2Id: 'team-miami-oh',
    team1Seed: 6,
    team2Seed: 11,
    team1Score: 78,
    team2Score: 56,
    nextGameId: 'game-2-15',
  },
  {
    id: 'game-1-30',
    round: 'first_round',
    region: 'midwest',
    team1Id: 'team-virginia',
    team2Id: 'team-wright-st',
    team1Seed: 3,
    team2Seed: 14,
    team1Score: 82,
    team2Score: 73,
    nextGameId: 'game-2-15',
  },
  {
    id: 'game-1-31',
    round: 'first_round',
    region: 'midwest',
    team1Id: 'team-kentucky',
    team2Id: 'team-santa-clara',
    team1Seed: 7,
    team2Seed: 10,
    team1Score: 89,
    team2Score: 84,
    nextGameId: 'game-2-16',
  },
  {
    id: 'game-1-32',
    round: 'first_round',
    region: 'midwest',
    team1Id: 'team-iowa-st',
    team2Id: 'team-tennessee-st',
    team1Seed: 2,
    team2Seed: 15,
    team1Score: 108,
    team2Score: 74,
    nextGameId: 'game-2-16',
  },
];

export const secondRoundGames: TournamentGame[] = [
  // EAST REGION
  {
    id: 'game-2-1',
    round: 'second_round',
    region: 'east',
    team1Id: 'team-duke',
    team2Id: 'team-tcu',
    team1Score: 81,
    team2Score: 58,
    nextGameId: 'game-3-1',
  },
  {
    id: 'game-2-2',
    round: 'second_round',
    region: 'east',
    team1Id: 'team-st-johns',
    team2Id: 'team-kansas',
    team1Score: 67,
    team2Score: 65,
    nextGameId: 'game-3-1',
  },
  {
    id: 'game-2-3',
    round: 'second_round',
    region: 'east',
    team1Id: 'team-louisville',
    team2Id: 'team-michigan-st',
    team1Score: 69,
    team2Score: 77,
    nextGameId: 'game-3-2',
  },
  {
    id: 'game-2-4',
    round: 'second_round',
    region: 'east',
    team1Id: 'team-ucla',
    team2Id: 'team-connecticut',
    team1Score: 57,
    team2Score: 73,
    nextGameId: 'game-3-2',
  },
  // WEST REGION
  {
    id: 'game-2-5',
    round: 'second_round',
    region: 'west',
    team2Id: 'team-utah-st',
    team1Id: 'team-arizona',
    team1Score: 78,
    team2Score: 66,
    nextGameId: 'game-3-3',
  },
  {
    id: 'game-2-6',
    round: 'second_round',
    region: 'west',
    team1Id: 'team-high-point',
    team2Id: 'team-arkansas',
    team1Score: 88,
    team2Score: 94,
    nextGameId: 'game-3-3',
  },
  {
    id: 'game-2-7',
    round: 'second_round',
    region: 'west',
    team1Id: 'team-texas',
    team2Id: 'team-gonzaga',
    team1Score: 74,
    team2Score: 68,
    nextGameId: 'game-3-4',
  },
  {
    id: 'game-2-8',
    round: 'second_round',
    region: 'west',
    team1Id: 'team-miami-fl',
    team2Id: 'team-purdue',
    team1Score: 69,
    team2Score: 79,
    nextGameId: 'game-3-4',
  },
  // SOUTH REGION
  {
    id: 'game-2-9',
    round: 'second_round',
    region: 'south',
    team1Id: 'team-florida',
    team2Id: 'team-iowa',
    team1Score: 72,
    team2Score: 73,
    nextGameId: 'game-3-5',
  },
  {
    id: 'game-2-10',
    round: 'second_round',
    region: 'south',
    team1Id: 'team-vanderbilt',
    team2Id: 'team-nebraska',
    team1Score: 72,
    team2Score: 74,
    nextGameId: 'game-3-5',
  },
  {
    id: 'game-2-11',
    round: 'second_round',
    region: 'south',
    team1Id: 'team-vcu',
    team2Id: 'team-illinois',
    team1Score: 55,
    team2Score: 76,
    nextGameId: 'game-3-6',
  },
  {
    id: 'game-2-12',
    round: 'second_round',
    region: 'south',
    team1Id: 'team-texas-am',
    team2Id: 'team-houston',
    team1Score: 57,
    team2Score: 88,
    nextGameId: 'game-3-6',
  },
  // MIDWEST REGION
  {
    id: 'game-2-13',
    round: 'second_round',
    region: 'midwest',
    team1Id: 'team-michigan',
    team2Id: 'team-saint-louis',
    team1Score: 95,
    team2Score: 72,
    nextGameId: 'game-3-7',
  },
  {
    id: 'game-2-14',
    round: 'second_round',
    region: 'midwest',
    team2Id: 'team-alabama',
    team1Id: 'team-texas-tech',
    team1Score: 65,
    team2Score: 90,
    nextGameId: 'game-3-7',
  },
  {
    id: 'game-2-15',
    round: 'second_round',
    region: 'midwest',
    team1Id: 'team-tennessee',
    team2Id: 'team-virginia',
    team1Score: 79,
    team2Score: 72,
    nextGameId: 'game-3-8',
  },
  {
    id: 'game-2-16',
    round: 'second_round',
    region: 'midwest',
    team2Id: 'team-iowa-st',
    team1Id: 'team-kentucky',
    team1Score: 63,
    team2Score: 82,
    nextGameId: 'game-3-8',
  },
];

export const sweetSixteenGames: TournamentGame[] = [
  // EAST REGION
  {
    id: 'game-3-1',
    round: 'sweet_sixteen',
    region: 'east',
    team1Id: 'team-duke',
    team2Id: 'team-st-johns',
    team1Score: 80,
    team2Score: 75,
    nextGameId: 'game-4-1',
  },
  {
    id: 'game-3-2',
    round: 'sweet_sixteen',
    region: 'east',
    team1Id: 'team-michigan-st',
    team2Id: 'team-connecticut',
    team1Score: 63,
    team2Score: 67,
    nextGameId: 'game-4-1',
  },
  // WEST REGION
  {
    id: 'game-3-3',
    round: 'sweet_sixteen',
    region: 'west',
    team1Id: 'team-arizona',
    team2Id: 'team-arkansas',
    team1Score: 109,
    team2Score: 88,
    nextGameId: 'game-4-2',
  },
  {
    id: 'game-3-4',
    round: 'sweet_sixteen',
    region: 'west',
    team1Id: 'team-texas',
    team2Id: 'team-purdue',
    team1Score: 77,
    team2Score: 79,
    nextGameId: 'game-4-2',
  },
  // SOUTH REGION
  {
    id: 'game-3-5',
    round: 'sweet_sixteen',
    region: 'south',
    team1Id: 'team-iowa',
    team2Id: 'team-nebraska',
    team1Score: 77,
    team2Score: 71,
    nextGameId: 'game-4-3',
  },
  {
    id: 'game-3-6',
    round: 'sweet_sixteen',
    region: 'south',
    team1Id: 'team-illinois',
    team2Id: 'team-houston',
    team1Score: 65,
    team2Score: 55,
    nextGameId: 'game-4-3',
  },
  // MIDWEST REGION
  {
    id: 'game-3-7',
    round: 'sweet_sixteen',
    region: 'midwest',
    team1Id: 'team-michigan',
    team2Id: 'team-alabama',
    team1Score: 90,
    team2Score: 77,
    nextGameId: 'game-4-4',
  },
  {
    id: 'game-3-8',
    round: 'sweet_sixteen',
    region: 'midwest',
    team1Id: 'team-tennessee',
    team2Id: 'team-iowa-st',
    team1Score: 76,
    team2Score: 62,
    nextGameId: 'game-4-4',
  },
];

export const eliteEightGames: TournamentGame[] = [
  {
    id: 'game-4-1',
    round: 'elite_eight',
    region: 'east',
    team1Id: 'team-duke',
    team2Id: 'team-connecticut',
    team1Score: 72,
    team2Score: 73,
    nextGameId: 'game-5-1',
  },
  {
    id: 'game-4-2',
    round: 'elite_eight',
    region: 'west',
    team1Id: 'team-arizona',
    team2Id: 'team-purdue',
    team1Score: 79,
    team2Score: 64,
    nextGameId: 'game-5-1',
  },
  {
    id: 'game-4-3',
    round: 'elite_eight',
    region: 'south',
    team1Id: 'team-iowa',
    team2Id: 'team-illinois',
    team1Score: 59,
    team2Score: 71,
    nextGameId: 'game-5-2',
  },
  {
    id: 'game-4-4',
    round: 'elite_eight',
    region: 'midwest',
    team1Id: 'team-michigan',
    team2Id: 'team-tennessee',
    team1Score: 95,
    team2Score: 62,
    nextGameId: 'game-5-2',
  },
];

export const finalFourGames: TournamentGame[] = [
  {
    id: 'game-5-1',
    round: 'final_four',
    team1Id: 'team-connecticut',
    team2Id: 'team-arizona',
    nextGameId: 'game-6-1',
  },
  {
    id: 'game-5-2',
    round: 'final_four',
    team1Id: 'team-illinois',
    team2Id: 'team-michigan',
    nextGameId: 'game-6-1',
  },
];

export const championshipGame: TournamentGame[] = [
  {
    id: 'game-6-1',
    round: 'championship',
  },
];

export const tournamentRounds: TournamentRound[] = [
  { name: 'First Four',    round: 'first_four',    gameCount: 4,  games: firstFourGames },
  { name: 'First Round',   round: 'first_round',   gameCount: 32, games: firstRoundGames },
  { name: 'Second Round',  round: 'second_round',  gameCount: 16, games: secondRoundGames },
  { name: 'Sweet Sixteen', round: 'sweet_sixteen', gameCount: 8,  games: sweetSixteenGames },
  { name: 'Elite Eight',   round: 'elite_eight',   gameCount: 4,  games: eliteEightGames },
  { name: 'Final Four',    round: 'final_four',    gameCount: 2,  games: finalFourGames },
  { name: 'Championship',  round: 'championship',  gameCount: 1,  games: championshipGame },
];

export const allTournamentGames: TournamentGame[] = [
  ...firstFourGames,
  ...firstRoundGames,
  ...secondRoundGames,
  ...sweetSixteenGames,
  ...eliteEightGames,
  ...finalFourGames,
  ...championshipGame,
];

export const getGamesByRound = (round: BracketRoundType): TournamentGame[] =>
  allTournamentGames.filter(game => game.round === round);

export const getGamesByRegion = (region: BracketRegion): TournamentGame[] =>
  allTournamentGames.filter(game => game.region === region);

export const getGameById = (gameId: string): TournamentGame | undefined =>
  allTournamentGames.find(game => game.id === gameId);

export const getRoundByName = (round: BracketRoundType): TournamentRound | undefined =>
  tournamentRounds.find(r => r.round === round);
